module.exports = __webpack_public_path__ + "static/media/file6.eae0f69c.jpg";